import React, { useState } from "react";
import HMC from "../../assets/images/logo.png";
import Button from "../Button/button";
import { AiFillCloseSquare } from "react-icons/all";
import { scrollTo } from "../../util";

const Navbar = ({ toRef, duration }) => {
  const [active, setActive] = useState(false);
  const handleClick = () => scrollTo({ ref: toRef, duration });

  const handleToggle = () => {
    setActive(!active);
  };
  return (
    <div>
      {active ? (
        <div
          className={`fixed xl:relative xl:hidden h-full w-full bg-black bg-opacity-60 `}
        ></div>
      ) : (
        ""
      )}

      <div
        className={`w-full pt-10 bg-white lg:bg-transparent ${
          active ? "pb-16  lg:pb-10 lg:bg-white  " : ""
        } lg:pb-0 lg:pt-8 text-text_color relative`}
        style={{ borderRadius: "0px 0px 40px 40px" }}
      >
        {active ? (
          <AiFillCloseSquare
            color="red"
            size="35px"
            // style={{ marginLeft: "320px" }}
            className="xl:hidden rounded-md lg:float-right lg:ml-5"
            onClick={() => {
              setActive(false);
            }}
          />
        ) : (
          ""
        )}

        <nav className="flex justify-around items-center content-center flex-wrap bg-transparent p-1 px-3 lg:px-20 relative z-10">
          <a className="inline-flex items-center p-2" href="/">
            <img
              src={HMC}
              alt="Heritage Men's Clinic"
              style={{ width: "215px", height: "48px" }}
            />
          </a>

          <button
            className={`${
              active ? "hidden" : "inline-flex"
            } p-3 rounded xl:hidden text-gray-800 ml-auto hover:text-gray-800 outline-none`}
            onClick={handleToggle}
          >
            <svg
              width="26"
              height="22"
              viewBox="0 0 26 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.5938 1.79688C25.5938 2.68572 24.8732 3.40625 23.9844 3.40625H2.42188C1.53303 3.40625 0.8125 2.68572 0.8125 1.79688C0.8125 0.908031 1.53303 0.1875 2.42188 0.1875H23.9844C24.8732 0.1875 25.5938 0.908031 25.5938 1.79688ZM20.375 11.0469C20.375 11.9357 19.6544 12.6562 18.7656 12.6562H2.42188C1.53303 12.6562 0.8125 11.9357 0.8125 11.0469C0.8125 10.158 1.53303 9.4375 2.42188 9.4375H18.7656C19.6544 9.4375 20.375 10.158 20.375 11.0469ZM11.7188 20.2656C11.7188 21.1544 10.9982 21.875 10.1094 21.875H2.42188C1.53303 21.875 0.8125 21.1544 0.8125 20.2656C0.8125 19.3768 1.53303 18.6562 2.42188 18.6562H10.1094C10.9982 18.6562 11.7188 19.3768 11.7188 20.2656Z"
                fill="black"
              />
            </svg>
          </button>
          <div
            className={`${
              active ? "" : "hidden"
            }   w-full xl:inline-flex xl:flex-grow xl:w-auto`}
          >
            <div className="xl:inline-flex xl:flex-row lg:mx-auto lg:w-auto w-full lg:items-center items-center text-center flex flex-col text-base font-Airbnb font-normal text-text_color lg:h-auto">
              <a
                className="xl:inline-flex lg:w-auto w-full lg:px-16 font-bold pt-10 lg:pt-5 rounded hover:font-bold items-center justify-center lg:justify-center lg:items-center  hover:no-underline border-b-2 border-transparent hover:text-gray-900"
                href="/"
              >
                Home
              </a>
              <a
                className="xl:inline-flex lg:w-auto w-full lg:px-16  pt-10 lg:pt-5 rounded hover:font-bold items-center justify-center lg:justify-center lg:items-center  hover:no-underline border-b-2 border-transparent hover:text-gray-900"
                href="/#secondSection"
              >
                About Us
              </a>
              <a
                className="xl:inline-flex lg:w-auto w-full lg:px-16  pt-10 lg:pt-5 pb-10 lg:pb-5 xl:pb-0 rounded hover:font-bold items-center justify-center lg:justify-center lg:items-center hover:no-underline border-b-2 border-transparent hover:text-gray-900"
                href="/#ourServices"
              >
                Our Service
              </a>
              <div className="block xl:hidden">
                {" "}
                <Button
                  onclick={handleClick}
                  text="Contact Us"
                  variant="secondary"
                />
              </div>
            </div>
          </div>
          <div className="hidden lg:hidden xl:block">
            {" "}
            <Button
              onclick={handleClick}
              text="Contact Us"
              variant="secondary"
            />
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
